import { render, staticRenderFns } from "./YogaProgram.vue?vue&type=template&id=20f263fe&scoped=true&"
import script from "./YogaProgram.vue?vue&type=script&lang=js&"
export * from "./YogaProgram.vue?vue&type=script&lang=js&"
import style0 from "./YogaProgram.vue?vue&type=style&index=0&id=20f263fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f263fe",
  null
  
)

export default component.exports